import './Advantage.css';

function advantage() {
    return (
        <div className="antivirus">
            <div className='payment-title'>Advantage</div>
            <div className="advantage-points">
                <div className="advantage-point">
                    <div className="advantage-point-title">6 layers of security</div>
                    <div className="advantage-point-content">Effortlessly run smart scans on software, files, and apps
                        to find vulnerabilities, plus analyze suspicious files in the cloud, get threat alerts, and
                        more.
                    </div>
                </div>
                <div className="advantage-point">
                    <div className="advantage-point-title">Easy to install and use</div>
                    <div className="advantage-point-content">It only takes a moment to install Avast Free Antivirus and
                        once it’s done, it’ll run quietly in the background, protecting you against viruses and other
                        malware in real time, 24/7
                    </div>
                </div>
                <div className="advantage-point">
                    <div className="advantage-point-title">Wi-Fi network security</div>
                    <div className="advantage-point-content">Connect safely to any Wi-Fi network, even unsecured public
                        networks, plus see who’s using your home Wi-Fi and block any intruders with a click.
                    </div>
                </div>
                <div className="advantage-point">
                    <div className="advantage-point-title">Protection against ransomware attacks</div>
                    <div className="advantage-point-content">Protect your information. Don't let your personal photos,
                        files, and documents fall victim to hackers using ransomware.
                    </div>
                </div>
            </div>
            <div className="advantage-points"></div>
        </div>
    );
}

export default advantage